module.exports = __webpack_public_path__ + "static/media/Instagram_Glyph_Gradient.dd11ddd0.png";